import { CompanyOpeningCurrentPhase } from '@/types'

export type CurrentStep = {
  step: string
  status: string
}

export function toCurrentStep(
  currentPhase: CompanyOpeningCurrentPhase,
): CurrentStep {
  return {
    step: currentPhase.label,
    status: currentPhase.message,
  }
}
